import { Button, Card, Col, Flex, Form, Input, Popover, Row, Select } from 'antd'
import React, { useState } from 'react'
import { t } from 'i18next'
import TextArea from 'antd/es/input/TextArea'
import PhoneInput from 'react-phone-number-input/input'
import { formatPhoneNumber, isValidPhoneNumber } from 'react-phone-number-input'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import { JOBS } from '../../Common/Common'

export default function BoxAccessibilityTab ({ form, interveners, state }) {
  const [displayedInterveners, setDisplayedInterveners] = useState(form.getFieldValue('interveners') || [])
  const [intervener, setIntervener] = useState()
  const [job, setJob] = useState()

  const addIntervener = () => {
    const addedIntervener = interveners.find(i => i.id === intervener)
    const iArray = [...displayedInterveners, addedIntervener]
    setDisplayedInterveners(iArray)
    form.setFieldValue('interveners', iArray)
    setIntervener(null)
  }

  const removeIntervener = (i) => {
    const iArray = [...displayedInterveners.filter(intervener => intervener.id !== i.id)]
    setDisplayedInterveners(iArray)
    form.setFieldValue('interveners', iArray)
  }

  const displayInterveners = () => {
    return (
      displayedInterveners.map(i => (
        <Popover key={i.id} content={i.description} placement='topLeft'>
          <Row style={{ flexFlow: 'row', marginBottom: '1em' }}>
            <Col span={3} style={{ marginRight: 'auto' }}><Card styles={{ body: { padding: '3px', textAlign: 'center' } }}>
              {t(`Admin.IntervenersList.table.job.${i.job}`)}
            </Card></Col>
            <Col span={6} style={{ marginRight: 'auto' }}><Card styles={{ body: { padding: '3px', textAlign: 'center' } }}>{i.name}</Card></Col>
            {displayCommunicationMeans(i.phones, i.emails)}
            <Button onClick={() => removeIntervener(i)} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<MinusOutlined />} />
          </Row>
        </Popover>
      ))
    )
  }

  const displayCommunicationMeans = (phones, emails) => {
    return (
      <>
        <Col span={4} style={{ marginRight: 'auto' }}>
          {phones.map(phone => (
            displayCommunication(phone)
          ))}
        </Col>
        <Col span={6} style={{ marginRight: 'auto' }}>
          {emails.map(email => (
            displayCommunication(email)
          ))}
        </Col>
      </>
    )
  }

  const displayCommunication = (communication) => {
    const value = communication.field_type === 'phone' ? formatPhoneNumber(`+${communication.value}`) : communication.value
    return (
      <>
        {communication.description &&
          <Popover content={communication.description}>
            <Card styles={ { body: { padding: '3px', textAlign: 'center' } }}>{value}</Card>
          </Popover>
        }
        {!communication.description &&
          <Card styles={{ body: { padding: '3px', textAlign: 'center' } }}>{value}</Card>
        }
      </>
    )
  }

  const filteredInterveners = (interveners, job, displayedInterveners) => {
    if (job) {
      return interveners?.filter(i => i.job === job && !displayedInterveners.map(e => e.id).includes(i.id))
    } else {
      return interveners?.filter(i => !displayedInterveners.map(e => e.id).includes(i.id))
    }
  }

  return (
    <Flex justify='space-between'>
      <div style={{ width: '45%' }}>
        <Flex justify='space-between'>
          <Form.Item name="interphone" label={t('Admin.BoxForm.interphone')}
            rules={[
              {
                validator: (_, value) =>
                  value === undefined || isValidPhoneNumber(value) ? Promise.resolve() : Promise.reject(new Error('Numéro incorrect'))
              }
            ]}>
            <PhoneInput country='FR' className='ant-input css-dev-only-do-not-override-xfszwz PhoneInput' disabled={state === 'show'} style={{ fontSize: '14px', padding: '4px 11px' }} />
          </Form.Item>
          <Form.Item name="pcc_phone" label={t('Admin.BoxForm.pcc_phone')}
            rules={[
              {
                validator: (_, value) =>
                  value ? (isValidPhoneNumber(value) ? Promise.resolve() : Promise.reject(new Error('Numéro incorrect'))) : Promise.resolve()
              }
            ]}>
            <PhoneInput country='FR' className='ant-input css-dev-only-do-not-override-xfszwz PhoneInput' disabled={state === 'show'} style={{ fontSize: '14px', padding: '4px 11px' }} />
          </Form.Item>
          <Col>
            <div style={{ marginBottom: '8px' }}>{t('Admin.BoxForm.cleanup_code')}</div>
            <div style={{ padding: '4px 11px', border: '#d9d9d9 solid 1px', borderRadius: '10px' }}>{form.getFieldValue('cleanup_code')}</div>
          </Col>
          <Col>
            <div style={{ marginBottom: '8px' }}>{t('Admin.BoxForm.daily_code')}</div>
            <div style={{ padding: '4px 11px', border: '#d9d9d9 solid 1px', borderRadius: '10px' }}>{form.getFieldValue('daily_code')}</div>
          </Col>
          <Col>
            <div style={{ marginBottom: '8px' }}>{t('Admin.BoxForm.emergency_code')}</div>
            <div style={{ padding: '4px 11px', border: '#d9d9d9 solid 1px', borderRadius: '10px' }}>{form.getFieldValue('emergency_code')}</div>
          </Col>
        </Flex>
        <h3>{t('Admin.BoxForm.locks')}</h3>
        <Flex justify='space-between'>
          <Form.Item name="lock_1" label={t('Admin.BoxForm.lock_1')}>
            <Input />
          </Form.Item>
          <Form.Item name="lock_2" label={t('Admin.BoxForm.lock_2')}>
            <Input />
          </Form.Item>
          <Form.Item name="lock_3" label={t('Admin.BoxForm.lock_3')}>
            <Input />
          </Form.Item>
          <Form.Item name="lock_4" label={t('Admin.BoxForm.lock_4')}>
            <Input />
          </Form.Item>
        </Flex>
        <Form.Item name="comment" label={t('Admin.BoxForm.comment')} style={{ width: '100%' }}>
          <TextArea rows={10} />
        </Form.Item>
      </div>
      <div style={{ width: '50%' }}>
        <h3 style={{ marginTop: '0' }}>{t('Admin.BoxForm.group.interveners')}</h3>
        <Row style={{ marginBottom: '2em' }}>
          <Select
            showSearch={{
              optionFilterProp: 'children',
              filterOption: (input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }}
            allowClear
            placeholder="Filtrer par fonction"
            options={JOBS.map((o) => ({ label: t(`Admin.IntervenersList.table.job.${o}`), value: o }))}
            onSelect={(value) => setJob(value)}
            onClear={() => setJob(null)}
            value={job}
            style={{ width: '18em' }}
          />
          <Select
            showSearch={{
              optionFilterProp: 'children',
              filterOption: (input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }}
            placeholder="Rechercher un intervenant"
            options={filteredInterveners(interveners, job, displayedInterveners).map((o) => ({ label: o.name, value: o.id }))}
            onSelect={(value) => setIntervener(value)}
            value={intervener}
            style={{ width: '23em' }}
          />
          <Button disabled={!intervener} onClick={addIntervener} type="primary" style={{ marginLeft: '2em' }} shape="circle" icon={<PlusOutlined />} />
        </Row>
        {displayInterveners()}
      </div>
    </Flex>
  )
}
